/**
 * 店家圖片相關資料模型
 * 用於處理 /stores/web/files 和 /stores/web/download API 的資料結構
 */

/**
 * 店家檔案列表回應模型
 */
export class StoresFilesRes {
    constructor(data = {}) {
        this.statusCode = data.statusCode || 0;
        this.reasonPhrase = data.reasonPhrase || '';
        this.data = new StoresFilesData(data.data || {});
    }
}

/**
 * 店家檔案資料模型
 */
export class StoresFilesData {
    constructor(data = {}) {
        this.msg = data.msg || '';
        this.files = (data.files || []).map(file => new StoresFile(file));
    }
}

/**
 * 單一檔案資訊模型
 */
export class StoresFile {
    constructor(data = {}) {
        this.fileName = data.file_name || '';
        this.fileSize = data.file_size || 0;
    }
}

/**
 * 店家圖片下載請求模型
 */
export class StoresDownloadReq {
    constructor(fileName) {
        this.data = JSON.stringify(new StoresDownloadData(fileName));
    }
}

/**
 * 店家圖片下載資料模型
 */
export class StoresDownloadData {
    constructor(fileName) {
        this.filename = fileName;
    }
}
